import React from "react";
import { Button } from "./Button";
import { AlertTriangle } from "lucide-react";
import CloseIcon from "@/components/icons/CloseIcon";

const DeleteConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Delete Record",
  userName,
  isLoading = false,
}) => {
  return (
    <div
      className={`fixed inset-0 z-50 backdrop-blur-sm transition-opacity duration-300 ${isOpen ? "opacity-100" : "pointer-events-none opacity-0"}`}
    >
      <div
        className={`fixed inset-0 bg-white bg-opacity-50 transition-opacity duration-300 ${isOpen ? "opacity-100" : "opacity-0"}`}
        onClick={onClose}
      ></div>
      <div className="fixed inset-0 flex items-center justify-center py-8 px-4 overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
        <div
          className={`relative z-50 w-full max-w-md transform rounded-2xl bg-navy-500 transition-all duration-300 shadow-2xl ${isOpen ? "scale-100 opacity-100" : "scale-95 opacity-0"
            } p-6`}
        >
          <CloseIcon
            className="absolute w-8 h-8 text-red-500 transition-transform duration-200 cursor-pointer top-2 right-2 hover:scale-110"
            onClick={onClose}
          />
          {/* Icon */}
          <div className="flex justify-center mb-4">
            <div className="flex items-center justify-center w-16 h-16 bg-red-100 rounded-full">
              <AlertTriangle className="w-8 h-8 text-red-600" />
            </div>
          </div>

          {/* Content */}
          <div className="mb-6 text-center">
            <h3 className="mb-2 text-xl font-semibold uppercase text-gray-0">{title}</h3>
            <p className="leading-relaxed text-gray-0">
              Are you sure you want to delete{" "}
              <span className="font-semibold text-red-600">{userName}</span>?
              <br />
              This action cannot be undone.
            </p>
          </div>

          {/* Actions */}
          <div className="flex gap-3">
            <Button
              variant="outline"
              onClick={onClose}
              className="flex-1 rounded-xl"
              disabled={isLoading}
            >
              Cancel
            </Button>
            <Button onClick={onConfirm} className="flex-1 rounded-xl" disabled={isLoading}>
              {isLoading ? "Deleting..." : "Delete"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmDialog;
